export default "__VITE_ASSET__BlMBbduL__"